import boxen from 'boxen';
import chalk from 'chalk';
import gradient from 'gradient-string';
import figlet from 'figlet';
import { getCliName } from './cli-name.js';

/**
 * Custom help screen với UI đẹp hơn
 */
export function showCustomHelp(version: string): void {
  // Header với gradient ASCII art
  const title = figlet.textSync('JAI1', { font: 'Small' });
  console.log(gradient.pastel(title));

  // Box với version
  console.log(
    boxen(chalk.cyan(`Agentic Coding CLI v${version}`), {
      padding: { left: 1, right: 1, top: 0, bottom: 0 },
      borderStyle: 'round',
      borderColor: 'cyan',
    })
  );

  // Grouped commands
  console.log(chalk.bold('\n🔧 Thiết lập & Thông tin'));
  console.log('   auth           Xác thực và cấu hình client');
  console.log('   status         Hiển thị trạng thái cấu hình');
  console.log('   client-info    Tạo thông tin client để gửi đội phát triển');
  console.log('   errors         Quản lý error logs cục bộ');
  console.log('   guide          Hướng dẫn sử dụng nhanh');
  console.log('   quickstart     Bắt đầu từ đâu? (theo tình huống)');
  console.log('   doctor         Chuẩn đoán project hiện tại');

  console.log(chalk.bold('\n📦 Quản lý Components'));
  console.log('   apply          Cài đặt components (interactive)');
  console.log('   update         Cập nhật components đã cài');
  console.log('   check          Kiểm tra cập nhật từ server');

  console.log(chalk.bold('\n🖥️  IDE & Tích hợp'));
  console.log('   ide            Lệnh cấu hình IDE');
  console.log('   chat           Chat AI với Jai1 LLM Proxy');
  console.log('   openai-keys    Thông tin API credentials');

  console.log(chalk.bold('\n🤖 AI Tools'));
  console.log('   translate      Dịch văn bản/file bằng AI');
  console.log('   image          Tạo ảnh (Coming Soon)');
  console.log('   stats          Thống kê sử dụng LLM');
  console.log('   feedback       Gửi báo cáo/đề xuất');

  console.log(chalk.bold('\n📁 Project'));
  console.log('   kit            Quản lý starter kits');
  console.log('   tasks (t)      Quản lý tasks phát triển');
  console.log('   rules          Quản lý rule presets');
  console.log('   deps           Quản lý dependencies');
  console.log('   redmine        Redmine context sync');

  console.log(chalk.bold('\n🛠️  Utilities'));
  console.log('   utils          Developer utilities');

  console.log(chalk.bold('\n⚙️  Bảo trì'));
  console.log('   upgrade        Cập nhật CLI client');
  console.log('   clean          Dọn dẹp cache/backup');

  const name = getCliName();
  console.log(chalk.dim(`\nSử dụng: ${name} [lệnh] --help để xem chi tiết`));
}

/**
 * Custom unknown command handler
 */
export function showUnknownCommand(commandName: string): void {
  console.error(chalk.red(`❌ Lệnh không tồn tại: ${commandName}`));
  const name = getCliName();
  console.error(chalk.dim(`\nGợi ý: Chạy ${name} --help để xem danh sách lệnh`));
}
